import { QueryClient, dehydrate, hydrate } from "@tanstack/react-query";
import { indexedDbStorage } from "./indexDBStorage";
import localforage from "localforage";

export const saveQueryData = async (
  queryClient: QueryClient,
  key: string = "react-query-cache"
) => {
  try {
    const state = dehydrate(queryClient);
    await indexedDbStorage.setItem(key, state);
  } catch (error) {
    // Handle QuotaExceededError
    console.error("Error saving data to indexedDb:", error);
  }
};

export const loadQueryData = async (
  queryClient: QueryClient,
  key: string = "react-query-cache"
) => {
  try {
    const savedData = await indexedDbStorage.getItem(key);
    if (savedData) {
      hydrate(queryClient, savedData);
    }
  } catch (error) {
    // remove the storage
    await indexedDbStorage.removeItem(key);
  }
};

// remove the saved query from old localStorage
// if it's not the same with current user
export const removeQueryData = async (currentUserID?: string) => {
  if (!currentUserID) return;

  try {
    // remove the saved query from old localStorage
    Object.entries(localStorage).forEach(async ([key, value]) => {
      if (currentUserID !== key && value.startsWith(`{"mutations":[]`)) {
        localStorage.removeItem(key);
      }
    });

    // Iterate over localforage entries and remove old query caches from other users
    await localforage.iterate((value: any, key: string) => {
      if (
        key !== currentUserID &&
        value &&
        typeof value === "object" &&
        "mutations" in value
      ) {
        localforage.removeItem(key);
      }
    });
  } catch (error) {
    console.error(error);
  }
};